var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46967 0.531193C0.762563 0.2383 1.23744 0.2383 1.53033 0.531193L6.46972 5.47059C6.76016 5.76103 7.23984 5.76103 7.53028 5.47059L12.4697 0.531193C12.7626 0.2383 13.2374 0.2383 13.5303 0.531193C13.8232 0.824087 13.8232 1.29896 13.5303 1.59185L8.59094 6.53125C7.71471 7.40747 6.28529 7.40747 5.40906 6.53125L0.46967 1.59185C0.176777 1.29896 0.176777 0.824087 0.46967 0.531193Z",
    fill: "#14477D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.9ae0733dffd9c081967f3652bc91222c.svg";
export { ForwardRef as ReactComponent };